<template>
  <v-app>
    <Navbar
      ref="navbar_comp"
      v-show="show_navbar"
      :primaryColor="primaryColor"
      v-if="
        $route.path != '/login' && $route.path != '/course/quizWeb'
          ? true
          : false
      "
    />
    <!--  -->
    <v-main class="bg">
      <router-view
        @toggleNavBarCall="toggleNavBarCall"
        style="padding-top: 1rem !important; padding-left: 1.6rem !important"
        :primaryColor="primaryColor"
      ></router-view>
    </v-main>
     <BlockOverlay :show="secureMode" />
  </v-app>
</template>

<style scoped lang="css">
.bg {
  background: url("~@/assets/Component 87 – 6@2x.png") no-repeat center center;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transform: scale(1);
}
</style>

<script>
import Navbar from "./components/Navbar";
import BlockOverlay from "./components/BlockOverlay.vue";
import html2canvas from "html2canvas";
export default {
  name: "App",

  components: {
    Navbar,
    BlockOverlay
  },

  data: () => ({
    //
    show_navbar: false,
    notiCount: 0,
    primaryColor: "#A6CC39",
    secureMode: false,
  }),

  mounted() {
  window.addEventListener('keyup', this.handlePrintScreen);
},
beforeDestroy() {
  window.removeEventListener('keyup', this.handlePrintScreen);
},
  methods: {
    toggleNavBarCall(v) {
      if (v == "userLogIn") {
        this.show_navbar = true;
      } else {
        this.show_navbar = false;
      }
    },
     async  handlePrintScreen(e) {
    if (e.key === "PrintScreen") {
      if (document.fullscreenElement) {
    await document.exitFullscreen();
  }
      this.secureMode = true;
         await this.$nextTick();
         setTimeout(() => {
    html2canvas(document.body).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "blocked.png";
      link.click();

      this.secureMode = false;
    });
  }, 300);
    //  setTimeout(() => {
    //    const blocker = document.querySelector(".overlay-blocker");
    //     blocker.style.height = document.body.scrollHeight + "px";
        
    //       html2canvas(document.body).then((canvas) => {
    //         const imgData = canvas.toDataURL("image/png");

    //         // Trigger download
    //         const link = document.createElement("a");
    //         link.href = imgData;
    //         link.download = "blocked.png";
    //         link.click();

    //         this.secureMode = false;
    //       });
    //     }, 300); 
    }
  },
  },
};
</script>
